import { WorkflowHistoryProps } from './types';
import { WorkflowHistoryController } from './workflow-history.controller';

const WorkflowHistory = (props: WorkflowHistoryProps): JSX.Element => {
  return <WorkflowHistoryController {...props} />;
};
export default WorkflowHistory;
